module.exports = __webpack_public_path__ + "resources/img/logo_default.f747db211622c7519816c76762d3c321.png";